import { DependencyList, useEffect, useState, Dispatch, SetStateAction } from 'react'
import { useIsMounted } from './use-is-mounted.hook'
import { toastService } from '@utils/toast.service'

type UseLoadMeta = {
  error: Error | null
  firstLoad: boolean
  loading: boolean
  reload: () => void
}

export const useLoad = <T>(
  initialData: T,
  promise: () => Promise<T>,
  dependencyList: DependencyList = [],
): [T, Dispatch<SetStateAction<T>>, UseLoadMeta] => {
  const [tick, setTick] = useState(0)
  const [firstLoad, setFirstLoad] = useState(false)
  const [data, setData] = useState<T>(initialData)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const isMounted = useIsMounted()
  useEffect(() => {
    promise()
      .then(data => {
        if (isMounted.current) setData(data)
      })
      .catch((e: Error) => {
        toastService.error(e.message)
        if (isMounted.current) setError(e)
      })
      .finally(() => {
        if (isMounted.current) setLoading(false)
        if (isMounted.current && !firstLoad) setFirstLoad(true)
      })

  }, [tick, ...dependencyList])
  const reload = () => setTick(tick + 1)
  return [
    data,
    setData,
    {
      error,
      firstLoad,
      loading,
      reload,
    },
  ]
}
